import * as yup from "yup";
import { ListingSortType } from "type/listing-sort";

/** A new Gallery Slider starts on List Date (Newest First) (MAX-4403 panel 5). */
export const DEFAULT_GALLERY_SORT = ListingSortType.LISTING_DATE.id;

/** Seconds per photo once Advance photos automatically is switched on (panel 6). */
export const DEFAULT_SECONDS_PER_PHOTO = 5;

/**
 * Kestrel hands `interval` to the carousel unchanged, and the carousel counts milliseconds, so the
 * seconds the form asks for are written out ×1000 (MAX-4403 Q14). A cleared field is NaN, as it
 * always was, and stays NaN.
 */
export const secondsToInterval = (seconds: number | undefined): number | undefined =>
	seconds === undefined ? undefined : seconds * 1000;

/** A Market source needs a market; the listings count is always needed. */
export const gallerySliderSchema = (featured: boolean) => ({
	marketId: yup
		.string()
		.test(
			"check-featued-market",
			"Market is Required.",
			(marketId) => featured || !!marketId,
		),
	maxResults: yup
		.number()
		.required("Max Number of Listings is required."),
});
